var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GalaxyApi } from "@/api";
import { errorMessageAsString, rethrowSimple } from "@/utils/simple-error";
import { CleanableSummary, CleanupResult, PaginationOptions } from "./Cleanup/model";
export function fetchDiscardedDatasetsSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/storage/datasets/discarded/summary");
        if (error) {
            rethrowSimple(error);
        }
        return new CleanableSummary(data);
    });
}
export function fetchDiscardedDatasets(options) {
    return __awaiter(this, void 0, void 0, function* () {
        options = options !== null && options !== void 0 ? options : new PaginationOptions();
        const { data, error } = yield GalaxyApi().GET("/api/storage/datasets/discarded", {
            params: { query: options },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function cleanupDatasets(items) {
    return __awaiter(this, void 0, void 0, function* () {
        const itemIds = items.map((item) => item.id);
        const { data, error } = yield GalaxyApi().DELETE("/api/storage/datasets", {
            body: { item_ids: itemIds },
        });
        if (error) {
            return new CleanupResult(undefined, items, errorMessageAsString(error));
        }
        return new CleanupResult(data, items);
    });
}
export function fetchDiscardedHistoriesSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/storage/histories/discarded/summary");
        if (error) {
            rethrowSimple(error);
        }
        return new CleanableSummary(data);
    });
}
export function fetchDiscardedHistories(options) {
    return __awaiter(this, void 0, void 0, function* () {
        options = options !== null && options !== void 0 ? options : new PaginationOptions();
        const { data, error } = yield GalaxyApi().GET("/api/storage/histories/discarded", {
            params: { query: options },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function cleanupHistories(items) {
    return __awaiter(this, void 0, void 0, function* () {
        const itemIds = items.map((item) => item.id);
        const { data, error } = yield GalaxyApi().DELETE("/api/storage/histories", {
            body: { item_ids: itemIds },
        });
        if (error) {
            return new CleanupResult(undefined, items, errorMessageAsString(error));
        }
        return new CleanupResult(data, items);
    });
}
export function fetchArchivedHistoriesSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/storage/histories/archived/summary");
        if (error) {
            rethrowSimple(error);
        }
        return new CleanableSummary(data);
    });
}
export function fetchArchivedHistories(options) {
    return __awaiter(this, void 0, void 0, function* () {
        options = options !== null && options !== void 0 ? options : new PaginationOptions();
        const { data, error } = yield GalaxyApi().GET("/api/storage/histories/archived", {
            params: { query: options },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
